import { IntendedUsePageContent, type TranslatedValue } from "@swo/storefront";
import { Facet } from "../../components/_shared-components/generic-listing-page/types";

export function getConfig(items: IntendedUsePageContent["items"], categoryLabel: TranslatedValue | string) {
  const categoriesMap = new Map(
    items
      .flatMap(item => (item.type === "product-item" ? [item] : []))
      .map(item => {
        const { key, name } = item.category;

        return { key, name };
      })
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(({ key, name }) => [key, name] as const),
  );

  const facets: Array<Facet> = [
    {
      __key: "category",
      label: categoryLabel,
      values: Array.from(categoriesMap.entries()).map(([key, value]) => ({
        label: value,
        value: key,
        count: 1,
      })),
    },
  ];

  return { facets };
}
